(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/brands/assets/javascripts/brands-hashmap.js') >= 0) return;  svs.modules.push('/components/ui/brands/assets/javascripts/brands-hashmap.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var svs = svs || {};

(function (svs) {
  'use strict';

  svs.ui = svs.ui || {};
  svs.ui.brands = svs.ui.brands || {};
  var isServerSide = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object',
      guards,
      config;

  if (isServerSide) {
    var trinidad = require('trinidad-core').core;

    guards = require('./brands-guards.es6');
    config = trinidad.config;
  } else {
    guards = svs.ui.brands.guards;
    config = {
      options: svs.core.config.data.svsconfig
    };
  }

  var definedEmblem = 'vinnare',
      path = '/images/ui/brands/',
      cdn = config.options && config.options.cdn ? config.options.cdn : '',
      hashedBrands = {
    '17ellermer': '17ellermer-e2385f82a17b4eac4fddb4900c53c5be04dacb2a.svg',
    '3irad': '3irad-bce07d596f694468f2df7c73fca57622f42c0ac4.svg',
    'bil-triss': 'bil-triss-5cf12e2e8b68943bfa69448471688e2ef7271494.svg',
    'bingo': 'bingo-062f865939e407b36130a57fdb452453f887dbeb.svg',
    'bomben': 'bomben-dddbdb8f1238bd3c761ccd40a30615a646319b1e.svg',
    'bomben-100': 'bomben-100-78da97855d840281c54019975b02eb39ee6d818a.svg',
    'casino': 'casino-b8d0c1289186539b9ac335fbd4005f723a2685f9.svg',
    'challenge': 'challenge-d71f9ac9d3b155a73f1fe6e8da82f9ccc8ff6581.svg',
    'challenge-100': 'challenge-100-69a654679b487bbda53ff061110a872c62f9bdaf.svg',
    'dubbel-triss': 'dubbel-triss-45407e769c774da493184219857675a8a0913ac1.svg',
    'em-tipset': 'em-tipset-b5f167d3a9ac6f22dda54aca58832dfc1084a3e0.svg',
    'eurojackpot': 'eurojackpot-8473209f81d79c0800628e564095a189b78a45e4.svg',
    'eurojackpot-100': 'eurojackpot-100-dc2573a6d1481fb58341cc18aeeb17d3a53a83db.svg',
    'europatipset': 'europatipset-fb816b10a6687720795ee85824fd7b756fcdd920.svg',
    'extratipset': 'extratipset-649dfc3fb034c0d23ddc93de239b8e1b2150617c.svg',
    'fler-lotter': 'fler-lotter-7d440dc3cc86ab624b7a3da06b698fb4b092f3e0.svg',
    'grasroten': 'grasroten-38f9dc017e8269d04af9d97a1128ad2f77f712f4.svg',
    'keno': 'keno-7dd226e7eb480c091541923e2ff530459c9fe8d7.svg',
    'kenoxpress': 'kenoxpress-44ba323f397c674f133739047d0d91cfa9d80478.svg',
    'kenoxpress-full': 'kenoxpress-full-ad522ab7e6131bbe9cd98c46ff41637f21ee225e.svg',
    'langen': 'langen-7bc20b8d3f3052d308a83fe769a3cfa009a55fee.svg',
    'langen-100': 'langen-100-eb927cf1a1c7ac6718c943cc60c83e9f0509f472.svg',
    'langenxl': 'langenxl-f103388cf37b24c59636cc0986b593c10bbb116b.svg',
    'langenxl-100': 'langenxl-100-e78a5104277cdad98b9dc1563f15006e92aeeadb.svg',
    'live': 'live-c4bb81bd435e1d6e703f8f9b20337cdf9c0cdd66.svg',
    'live-100': 'live-100-0d19c4c132bb1fb6a2d2da847e8c6e609758a538.svg',
    'live-casino': 'live-casino-c549d3896a4e918cfe914db11ae29df590b09028.svg',
    'lordagsgodis': 'lordagsgodis-2cd0807d6304aa499a0dc0d5fcae380f3c15d8cb.svg',
    'lordagsgodis-oneline': 'lordagsgodis-oneline-961321fbd85880468b4f18b35c6c1cb6fd71f173.svg',
    'lordagsgodis-oneline-red': 'lordagsgodis-oneline-red-7a5abb4bcbcc25a80db062bdfa76d828924ad689.svg',
    'lordagsgodis-red': 'lordagsgodis-red-8383af45727affc604056ef58dffd9539a39d382.svg',
    'lotto': 'lotto-aeb80ed799e823b4a2ca84abcf1f572492cff516.svg',
    'maltipset': 'maltipset-cef6b5bb535afc06fb20c47269da18fc59568b34.svg',
    'matchen': 'matchen-69e6635a177b883c8bba1db1fa56dad4f2da076c.svg',
    'matchen-100': 'matchen-100-345edb7b351e0ebf619126a2769758a9e212994e.svg',
    'mini-triss': 'mini-triss-b5ce1baf6df3417e7007e49709f866722c7de89a.svg',
    'mittemellan': 'mittemellan-a1ada7c75999fc0ed8ce56c7cd5aa87e9680e305.svg',
    'mixen': 'mixen-48263b274f278211fb3a1f17cfa451bdc8bc728d.svg',
    'mixen-100': 'mixen-100-4b98ed23139444dd3d9b6a1b336ee9708730529d.svg',
    'mixenxl': 'mixenxl-b7cb3ec838967b6950464d390a9e1b1231e8b229.svg',
    'mixenxl-100': 'mixenxl-100-d4b3abeb147e33c10b2447883bff4dbf5e010dfb.svg',
    'oddset': 'oddset-311ede0abbdf2e1a6f22de8cbde3bc75480f1f52.svg',
    'oddset-100': 'oddset-100-ea5a8e9374290bb294ff5f353be8ee244545a2a0.svg',
    'poker': 'poker-427d9985d2e00c4084b2ead21fa6fa649e63c2af.svg',
    'powerplay': 'powerplay-c3c64495239b69b73389951d1690a0c9c68902ae.svg',
    'powerplay-100': 'powerplay-100-a542e06e7132be4b8e429eba4e48a68dc4c4e458.svg',
    'rubbet': 'rubbet-876e31aa7c83ef39dc24791ff04cbaacdb2f70ef.svg',
    'rubbetcom': 'rubbetcom-94218c7a0f6d442c67f9298c70940225e8029d7a.svg',
    'skrap-bingo': 'skrap-bingo-433b0431f3fee932d76bbecb359706e7cae3677f.svg',
    'skrap-kryss': 'skrap-kryss-60fa1fe37f583c9ade8c19f96ae05751910c2cdb.svg',
    'skrap-matcha': 'skrap-matcha-170c6a327790f412acde575f248ed990ad72dccc.svg',
    'skrap-pacman': 'skrap-pacman-e91b55c1af1a16065cf083f4a289e6ae19915517.svg',
    'skrap7an': 'skrap7an-b28db63f8e9fd237f931ebc5ced6b695a006c1f3.svg',
    'skrapspel': 'skrapspel-e11b1dae18b88eff7a2a7bb293ea5cf2459baf3d.svg',
    'stryktipset': 'stryktipset-62761c80bb4cb86e43cbcf74cfaf19bdf01dcf8f.svg',
    'svenskaspel': 'svenskaspel-71345c4fed1c985ea6fa377706cc2ae2a64d10d0.svg',
    'svenskaspel-100': 'svenskaspel-100-79021ef2f5dfa78a7159a1a2e5281334a0630022.svg',
    'svenskaspel-twolines': 'svenskaspel-twolines-53725cf7571a5c1bf38853094903013b1dbfa679.svg',
    'svenskaspel-twolines-neg': 'svenskaspel-twolines-neg-f9698ff1dbef4ded669af84af890178e79b791dd.svg',
    'topptipset': 'topptipset-85730a3395a991e4187fb1609257f410b2bec4c6.svg',
    'trav-galopp': 'trav-galopp-3cc432dc058f56e4e6f3b81acb36e7a345985c29.svg',
    'trav-galopp-primary': 'trav-galopp-primary-94b043c1532f7fc5ad2f53b9599f6974967114ef.svg',
    'trav-galopp-secondary': 'trav-galopp-secondary-fc0d69b530a2b979cadd1a03816722ed2bb6d44a.svg',
    'triss': 'triss-1a7840ae7535cf695feb2f272bbff6a9578e1dd6.svg',
    'vikinglotto': 'vikinglotto-23adc6306c980ab9ccf9c8ddb3464e33051c9c00.svg',
    'vinnare': 'vinnare-fa8fe4cd758e68d7a7865a742c25b3c57a5c196b.svg',
    'vinnare-new': 'vinnare-new-124474ad181e8c4d7b36e8c6d6e622304800e317.svg',
    'vm-tipset': 'vm-tipset-649dfc3fb034c0d23ddc93de239b8e1b2150617c.svg'
  };

  svs.ui.brands.getBrand = function (brand, size) {
    var hashedStr = guards.guard(brand),
        guardedBrand = hashedStr;

    if (hashedBrands[hashedStr] && size > 0) {
      hashedStr = hashedBrands[hashedStr + '-' + size] ? hashedStr + '-' + size : hashedStr;
    }

    return {
      brand: guardedBrand,
      svg: cdn + path + hashedBrands[hashedStr]
    };
  };

  svs.ui.brands.getEmblem = function () {
    return cdn + path + hashedBrands[definedEmblem];
  }; 


  if (isServerSide) {
    module.exports = svs.ui.brands;
  }
})(svs);
 })(window);